import { jsx as a } from "react/jsx-runtime";
import { createContext as p, useState as m, useEffect as u, useMemo as c, useContext as d } from "react";
import { useHistory as h } from "react-router-dom";
const n = p(void 0), A = ({
  defaultMain: t,
  children: s
}) => {
  h();
  const [e, r] = m(t), o = window.location.pathname.split("/");
  o[3], o[4], o[5], u(() => {
    r(t);
  }, [t]);
  const i = c(() => e, [e]);
  return /* @__PURE__ */ a(n.Provider, { value: i, children: s });
}, P = () => {
  const t = d(n);
  if (t === void 0)
    throw new Error("useCount must be used within a CountProvider");
  return t;
};
export {
  A,
  P as u
};
